import useTranslation from '@/hooks/use-translation';
import { Facebook, Instagram, Linkedin, TwitterX } from '@drivekyte/icons';
import { Box, IconButton, Typography } from '@drivekyte/ui';
import Image from 'next/image';

const SOCIALS = [
  {
    icon: Instagram,
    url: 'https://www.instagram.com/kyte/?hl=en',
  },
  {
    icon: Facebook,
    url: 'https://www.facebook.com/drivekyte/',
  },
  {
    icon: TwitterX,
    url: 'https://www.twitter.com/DriveKyte',
  },
  {
    icon: Linkedin,
    url: 'https://www.linkedin.com/company/drivekyte/',
  },
];

const FooterSocial = () => {
  const { t } = useTranslation('pages.home-page.footer');

  const handleOpenStore = (store: string) => () => {
    window.location.href = t(`stores.${store}.link`);
  };

  const handleOpenURL = (url: string) => () => {
    window.location.href = url;
  };

  const getTrimmedURLString = (url: string) => {
    return String(url).split('.')[1];
  };

  return (
    <Box width="100%" gap="$small">
      <Box width="100%" height={1} backgroundColor="$borderDefault" />
      <Box
        justifyContent="space-between"
        flexWrap="wrap"
        flexDirection="row"
        rowGap="$medium"
      >
        <Box flexDirection="row" display="flex" gap="$tiny">
          <Image
            width={108}
            height={36}
            src="/images/app-store.png"
            alt="Download on App Store"
            onClick={handleOpenStore('ios')}
            style={{ cursor: 'pointer' }}
          />
          <Image
            width={108}
            height={36}
            src="/images/google-play.png"
            alt="Download on Google Play"
            onClick={handleOpenStore('android')}
            style={{ cursor: 'pointer' }}
          />
        </Box>
        <Box gap="$tiny" flexDirection="row">
          {SOCIALS.map(({ icon, url }) => (
            <IconButton
              key={url}
              variant="secondary"
              size="small"
              icon={icon}
              onPress={handleOpenURL(url)}
              aria-label={`${getTrimmedURLString(url)}-button`}
            />
          ))}
        </Box>
      </Box>
      <Typography variant="paragraphXSmall" color="$contentSecondary">
        {t('copyrights', { year: new Date().getFullYear() })}
      </Typography>
    </Box>
  );
};

export default FooterSocial;
